import React, {Component} from "react";
import {Link} from "react-router-dom";
import HeaderRight from "../layouts/HeaderRight";
import {post} from './../../networking/Api'
import Constent from './../../networking/Constent';
import helpers from './../../networking/Helpers';
import {Alert} from "./../../alertServices";
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import {
    PullToRefresh,
    PullDownContent,
    ReleaseContent,
    RefreshContent
  } from "react-js-pull-to-refresh";

class ProjectList extends Component {
    constructor(props) {
        super(props);
        this.state={
          project_list:[],
          total_record_count: -1,
          count_active_project: 0,
          count_inactive_project: 0,
       
          project_type : 'active_project'
        }

        this.handleRefresh = this.handleRefresh.bind(this);
    }

    handleRefresh() {
        return new Promise(resolve => {
            this.getProjectList(this.state.project_type, resolve);
        });
      }


    componentDidMount(){
        this.getProjectList(this.state.project_type);
    }

    getProjectList(project_type = null, resolve){
        this.setState({total_record_count : -1,project_list:[]});
        var project_status = (project_type === 'active_project') ? 'active' : 'inactive';
        var formData=new FormData();
        formData.append("project_status",project_status);
        formData.append("department_id",localStorage.getItem('department_id'));
        formData.append("user_id",localStorage.getItem('userid'));
        if(localStorage.getItem('user_type') === 'user'){
          var api = Constent.GETPROJECT;
        }else{
          api = Constent.GETALLPROJECT;
        }
        post(api,formData).then(response =>{
            if(response.status===1){
              this.setState({
                project_list:response.data,
                total_record_count :response.record_total,
                count_active_project :response.count_active,
                count_inactive_project :response.count_inactive,
            })
            }

            if(resolve) {
                resolve();
            }
        })
    }

    selectDropdown = (val) => {
        this.setState({project_type:val});
        this.getProjectList(val); 
    };

    render() {
        const { t } = this.props;
        return (
            <>
            <div className="header-area projectlist-page" style={{'borderRadius': 0}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <Link className="menu-back-page home-clicked" to={'/'}>
                                    <i className="fa fa-home" />
                                </Link>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <div className="page-name">{t('lang.menu_name_project')}</div>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                               <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mg-top-30 projectlist-page sub-header"></div>
                <select className="form-control" style={{background:'#E6E6E6',broder:'1px solid #CCCCCC',paddingLeft: 20}}
                    value={this.state.project_type}
                    onChange={e => { this.selectDropdown(e.target.value)}}>
                    <option value="active_project" key={Math.random()} >{t('lang.project_sc_active_project')}</option>
                    <option value="inactive_project" key={Math.random()}>{t('lang.project_sc_inactive_project')}</option>
                </select>

            <PullToRefresh
                pullDownContent={<PullDownContent label='' />}
                releaseContent={false}
                refreshContent={<RefreshContent />}
                pullDownThreshold={2}
                onRefresh={this.handleRefresh}
                triggerHeight={500}
                startInvisible= {true}
            > 
                
                <div className='projectlist-page transaction-area mg-bottom-40'>
                    <div style={{marginTop:20}}>
                        {this.state.total_record_count < 0 ? <p className="text-center">{t('lang.common_text_loading') }</p> : '' }
                        {this.state.total_record_count === 0 ? <p className="text-center"> {t('lang.message__no_record_available')}</p> : '' }
                        {this.state.project_list.map(({ project_id, project_name,project_start,attachment_count, comment_count,task_completed,task_open, index}) => (
                        <div className='single-goal project-div' key={Math.random()}>
                            <Link to={'/project-details/'+project_id}>
                                <div className="row">
                                    <div className="col-10">
                                        <b className="text-overflow">{project_name}</b>
                                    </div>
                                    <div className="col-2 color-gray">
                                       <i className="la la-angle-right"></i>
                                    </div>
                                </div>
                                <p style={{margiBottom: 5}}>{task_open} {t('lang.project_sc_open_tasks')}, {task_completed} {t('lang.project_sc_tasks_completed')}</p>
                                <div className="progress mb-1" style={{'height': '0.3rem'}}>
                                    <div className="progress-bar" role="progressbar" style={{width: ( (task_completed * 100) / (task_open + task_completed) )  +'%'}} aria-valuenow={( (task_completed * 100) / (task_open + task_completed) )} aria-valuemin="0" aria-valuemax="100" />
                                </div>
                                <div className="row color-gray">
                                    <div className="col-8">
                                        <i className="fa fa-calendar" aria-hidden="true"></i> &nbsp;&nbsp;
                                        {moment(project_start, "YYYY-MM-DD").format("MMM DD,YYYY")}
                                    </div>
                                    <div className="col-2 text-right">
                                       <i className="fa fa-paperclip" aria-hidden="true"></i>
                                       {attachment_count}
                                    </div>
                                    <div className="col-2">
                                       <i className="fa fa-comment-o" aria-hidden="true"></i>
                                       {comment_count}
                                    </div>
                                </div>
                            </Link>
                       </div>
                        ))}
                    </div>
                </div>
            </PullToRefresh>
            {/* transaction End */}
           
    
            {/* Footer start */}
                <div className="footer-area">
                    <div className="container">
                        <div className="footer-bottom text-center">
                            <div className="row center">
                               <div className="col-8 offset-2 center">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td className="text-right">{t('lang.project_sc_active_project')}</td>
                                            <td>:</td>
                                            <td style={{width:30}}>{this.state.count_active_project}</td>
                                        </tr>
                                        <tr>
                                            <td>{t('lang.project_sc_inactive_project')}</td>
                                            <td>:</td>
                                            <td style={{width:30}}>{this.state.count_inactive_project}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-2">
                                    <Link className="home-clicked" to={'/'}>
                                        <i className="fa fa-home" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer End */}
            </>
        );
    }
}

export default withTranslation('common')(ProjectList);